const env = require("app/services/env");
const assign = require("object-assign");

class Debugger {

	expose(vars) {
		//if (env.debug() && env.client()) {
            assign(window, vars);
		//}

		return this;
	}

	alert(message, callback) {
		if (typeof message === "function") {
			callback = message;
			message = null;
		}

		try {
			if (typeof message === "string") {
				alert(message);
			}

			return callback();
		}
		catch (err) {
			alert(err && err.message ? err.message : `Unknown error: ${err}`);
		}
	}

}

module.exports = new Debugger();
